/**
 * Derive the tenant id from the current host so every API call can carry
 * X-Tenant-ID. The backend resolves the tenant from this header; without it,
 * requests hit the API host (api.originsovereign.co) which has no tenant
 * subdomain and silently falls back to the `default` tenant — wrong on any
 * tenant subdomain (e.g. anubis.originsovereign.co).
 *
 * Mirrors the logic in lib/marketing/api.ts apiFetch. Shared so the raw-fetch
 * paths (price, rebase-rate, subscription, tenant-config) stay tenant-aware.
 */
export function tenantIdFromHost(): string {
  if (typeof window === "undefined") return "default";
  const meta = document.querySelector<HTMLMetaElement>('meta[name="tenant-id"]');
  if (meta?.content) return meta.content;
  const first = window.location.host.split(".")[0];
  return first && first !== "localhost" ? first : "default";
}
